import React from "react";
import TeaserVenueContent from "@default/teasers/venue/components/teaser-venue-content";
import TeaserVenueImage from "@default/teasers/venue/components/teaser-venue-image";

const TeaserVenueStructureSimple = ({item, expanded}) => {
  return (
    <div className="row">
      <div className={"col-12 col-md-6 image-col"}>
        <TeaserVenueImage
          item={item}
        />
      </div>

      <div className={"col-12 col-md-6 info-col"}>
        <div className="name-wrapper infos">
          {item.label && <h2 className="name">{item.label}</h2>}
        </div>

        <TeaserVenueContent
          item={item}
          expanded={expanded}
        />
      </div>

    </div>
  );
}

export default TeaserVenueStructureSimple;